import { Controller } from "@hotwired/stimulus"

// Paired with `[data-scene="gallery"]`. Listens for `portfolio:active`
// CustomEvents dispatched by `DeviceGalleryScene` and swaps the active
// portfolio caption (heading + body + 2-3 supporting thumbnails) by
// toggling a `data-active="true"` attribute on the matching panel.
//
// Markup contract:
//   <section data-controller="portfolio-gallery" data-scene="gallery" …>
//     <div class="…">[3D canvas overlay here]</div>
//     <aside data-portfolio-gallery-target="panel">
//       <article data-slug="hebe"        data-active="true">…</article>
//       <article data-slug="pinterusaha">…</article>
//       …
//     </aside>
//   </section>
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this._onActive = (event) => this._swap(event.detail.slug)
    this.element.addEventListener("portfolio:active", this._onActive)
  }

  disconnect() {
    this.element.removeEventListener("portfolio:active", this._onActive)
  }

  _swap(slug) {
    if (!this.hasPanelTarget) return
    const articles = Array.from(this.panelTarget.querySelectorAll("[data-slug]"))
    articles.forEach(a => {
      a.toggleAttribute("data-active", a.dataset.slug === slug)
    })
  }
}
